
import * as quicklink from "quicklink";
//import * as $ from "jquery";
import "waypoints/lib/jquery.waypoints.js";
import "waypoints/lib/shortcuts/inview.js";
import "waypoints/lib/shortcuts/sticky.js";
import "waypoints/lib/shortcuts/infinite.js";

declare global {
    interface JQuery {
        waypoint(handler: (this: Waypoint, direction?: string) => void, options?: WaypointOptionsJQuery): JQuery;
        waypoint(options?: WaypointOptionsJQuery): JQuery;
    }

    interface WaypointOptionsJQuery extends WaypointOptionsBase {
        handler?: ((this: Waypoint, direction?: string) => void) | undefined;
        context?: HTMLElement | string | undefined;
    }
}

interface PageInfo {
    isFrontPage: boolean;
    isArchive: boolean;
    isHome: boolean;
    isSingle: boolean;
    isCategory: boolean;
    isMobile: boolean;
    baseUrl: string;
    title: string;
    currentUrl: string;
    ajaxUrl: string;
    debug: boolean;
}

class PageScript {
    info: PageInfo;

    constructor(info: PageInfo) {
        this.info = info;
    }

    init() {
        this.initQuicklink();
        this.initWaypoints();
        this.setupScrollAnimations();
        this.handleSmartSticky();

        if (this.info.debug) {
            this.log("Debug mode");
            $("#viewport-helper").show();
        }

        if (this.info.isFrontPage) {
            this.setup3dcards();
        }
    }

    private handleSmartSticky() {
        this.log("handleSmartSticky");

        var sticky = $(".smart-sticky");

        if (sticky.length == 0) return;

        for (var n = 0; n < sticky.length; n++) {

            var elem = sticky[n];

            // Get element top position
            var top = $(elem).offset().top;

            // Set element top position
            $(elem).css('top', top + 'px');
            $(elem).css('position', 'sticky');

        }

    }

    private setup3dcards() {

        $(document).on('mousemove', '.hover-layer', function (event) {

            var halfW = (this.clientWidth / 2);
            var halfH = (this.clientHeight / 2);

            var coorX = (halfW - (event.pageX - $(this).offset().left));
            var coorY = (halfH - (event.pageY - $(this).offset().top));

            var degX = ((coorY / halfH) * 8) + 'deg';
            // max. degree = 10
            var degY = ((coorX / halfW) * -8) + 'deg';
            // max. degree = 10

            $(this).css('transform', function () {
                return 'perspective( 600px ) translate3d( 0, -2px, 0 ) rotateX(' + degX + ') rotateY(' + degY + ')';
            });
        }).on('mouseout', '.hover-layer', function () {
            $(this).removeAttr('style');
        });
    }

    private initQuicklink() {
        this.log("initQuicklink")
        quicklink.listen({
            timeout: 1000,
            ignores: [
                /\/api\/?/,
                // Target url contains .php
                (uri, elem) => elem.hasAttribute('href') && elem.getAttribute('href').indexOf('.php') > -1,
                (uri, elem) => elem.hasAttribute('noprefetch')
              ]
        });
    }

    private initWaypoints() {
        this.log("initWaypoints");
    }

    private log(text: any) {
        if (this.info.debug) {
            if (typeof console !== "undefined" && typeof console.log !== "undefined")
                console.log(text);
        }
    }

    private getParameters(rawNames: any) {

        if (typeof rawNames === 'undefined' || rawNames === null || rawNames === '')
            return null;

        let classNames: string;

        if (typeof rawNames === 'object') {
            if (rawNames.baseVal !== undefined)
                classNames = rawNames.baseVal;
            else if (rawNames.animVal !== undefined)
                classNames = rawNames.animVal;
            else
                return null;
        } else
            classNames = rawNames;

        var classes = classNames.split(/\s+/);

        for (var i = 0; i < classes.length; i++) {

            var cls = classes[i];

            if (startsWith(cls, 'animate-')) {

                var params = cls.split('-');

                if (params.length != 3) {
                    this.log('Found invalid class: ' + cls);
                    continue;
                }

                var offset = params[1] + '%';
                var animationClass = params[2];

                return { offset: offset, animationClass: animationClass, keepOnTrigger: false };
            }
        }

        return null;
    }

    // animate-{percent}-{animationClass}

    private handleWaypoint(ts, parameters) {

        return function () {
            this.log(ts);
            this.log('triggered');
            this.log(ts.element);

            $(ts.element).addClass(parameters.animationClass);

            if (!parameters.keepOnTrigger)
                ts.destroy();
        };
    }

    private setupScrollAnimations() {
        this.log("setupScrollAnimations");

        var elements = $("[class^='animate-'],[class*=' animate-']");

        for (var n = 0; n < elements.length; n++) {

            var elem = elements[n];

            var parameters = this.getParameters(elem.className);
            //log(parameters);

            if (parameters == null) continue;

            $(elem).css('opacity', '0').addClass('animated').waypoint({
                handler: (() => {

                    //var ts = this;
                    var parms = parameters;

                    return function () {
                        $(this.element).addClass(parms.animationClass);

                        if (!parms.keepOnTrigger)
                            this.destroy();
                    };
                })(),
                offset: parameters.offset
            });
        }
    }

    /**
     * Detect the current active responsive breakpoint in Bootstrap
     * @returns {string}
     * @author farside {@link https://stackoverflow.com/users/4354249/farside}
     */
    private getResponsiveBreakpoint() {
        var envs = {
            xs: "d-none",
            sm: "d-sm-none",
            md: "d-md-none",
            lg: "d-lg-none",
            xl: "d-xl-none"
        };
        var env = "";

        var $el = $("<div>");
        $el.appendTo($("body"));

        for (var i = Object.keys(envs).length - 1; i >= 0; i--) {
            env = Object.keys(envs)[i];
            $el.addClass(envs[env]);
            if ($el.is(":hidden")) {
                break; // env detected
            }
        }
        $el.remove();
        return env;
    }

    private getParameterByName(name: string, url: string): string {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    private getScroll() {
        if (window.pageYOffset != undefined) {
            return { x: pageXOffset, y: pageYOffset };
        } else {
            var sx, sy, d = document,
                r = d.documentElement,
                b = d.body;
            sx = r.scrollLeft || b.scrollLeft || 0;
            sy = r.scrollTop || b.scrollTop || 0;
            return { x: sx, y: sy };
        }
    }

}

$(function () {
    const pageInfo: PageInfo = window["pageInfo"];
    // Tage the debug parameter from the debug url parameter
    pageInfo.debug = window.location.search.indexOf("debug") > -1;
    const pageScript = new PageScript(pageInfo);
    pageScript.init();
});

function startsWith(str: string, prefix: string) {
    return str.indexOf(prefix) === 0;
}